const en = {
  // Coach Landing Page (New Home)
  coachLanding: {
    tagline: 'The platform connecting sports coaches with athletes in their neighborhood',
    discoverMotivya: 'Discover Motivya',
    // Animated Pitch Scenes
    scene1Text: 'Are you a coach or fitness trainer?',
    scene1Subtext: 'Brussels needs you',
    scene2Text: 'Tired of finding clients?',
    scene2Subtext: 'No more paperwork and admin',
    scene3Text: 'Do you have 4+ hours per week?',
    scene3Subtext: 'Generate additional income',
    scene4Text: 'You plan, Motivya does the rest',
    scene4Subtext: 'Participants come automatically',
    scene5Text: 'Focus on your passion',
    scene5Subtext: 'Zero paperwork • Automatic clients • Local impact',
    selectedBadge: 'You are selected to become an Ambassador',
    ambassadorSpots: 'ambassador spots',
    inBrussels: 'in Brussels',
    reservedSpots: 'Reserved spots',
    onlyRemaining: 'Only {count} spots left!',
    ctaButton: 'Become an Ambassador Coach',
    discoverMore: 'Discover the benefits',
    whyJoin: 'Why join Motivya?',
    advantagesTitle: 'All the benefits of being an ambassador coach',
    advantagesSubtitle: 'Join the first 90 founding coaches and enjoy exclusive lifetime benefits',
    zeroRisk: 'Zero risk',
    zeroRiskDesc: 'You set a minimum participant threshold. If not reached, the session is cancelled at no cost.',
    commissionHalved: 'Commission ÷ 2',
    commissionHalvedDesc: 'As an ambassador, your commission is halved for life (10% instead of 20%).',
    clientsProvided: 'Clients provided',
    clientsProvidedDesc: 'Motivya broadcasts your sessions to athletes in your area. Clients come to you.',
    flexibleSchedule: 'Flexible schedule',
    flexibleScheduleDesc: 'Create your sessions when and where you want. You are your own boss.',
    guaranteedIncome: 'Guaranteed income',
    guaranteedIncomeDesc: 'Automatic payment after each session. No invoicing, no admin work.',
    founderStatus: 'Founder status',
    founderStatusDesc: 'Maximum visibility from launch. The best time slots are yours.',
    howItWorksTitle: 'How does it work?',
    step1Title: 'Create your profile',
    step1Desc: 'In 2 minutes, present your specialities and experience.',
    step2Title: 'Publish your sessions',
    step2Desc: 'Set location, time, price and minimum number of participants.',
    step3Title: 'Receive your payments',
    step3Desc: 'Bookings come in, the session takes place, you get paid automatically.',
    finalCtaTitle: 'Ready to launch your business?',
    finalCtaSubtitle: 'Join Motivya\'s founding coaches and grow your client base effortlessly.',
    freeNoCommitment: 'Free signup • No commitment • Validation within 48h',
  },

  nav: {
    explore: 'Explore',
    becomeCoach: 'Become a Coach',
    login: 'Sign in',
    register: 'Get Started',
    dashboard: 'Dashboard',
    admin: 'Admin',
    logout: 'Log out',
    coach: 'Coach',
    profile: 'Profile',
    favorites: 'Favourites',
    outfit: 'Outfit',
  },

  sessions: {
    join: 'Join session',
    viewAll: 'View all sessions',
    viewCoachSessions: 'View sessions',
  },

  landing: {
    // New hero messaging
    heroTitle: 'Sports in your neighbourhood starts here.',
    heroSub: 'Discover and join',
    intention: 'sports activities',
    in: 'around',
    action: 'you',
    heroDesc: 'Join sports sessions near you, today.',
    searchPlaceholder: 'Where do you want to work out?',
    search: 'Search',
    nearMe: 'Find a session',
    allActivities: 'Explore all activities',
    sessionsStartingIn3h: 'sessions in the next 3 hours in',
    startingSoonTitle: 'Starting soon near you',
    sessions: 'Sessions',
    coaches: 'Coaches',
    avgRating: 'Average rating',
    // Activities nearby section
    nearbyTitle: 'Activities near you',
    nearbySubtitle: 'Join a session now',
    joinSession: 'Join session',
    participants: 'participants',
    peopleParticipating: 'people already participating',
    // Weekly sessions section
    weeklyTitle: 'Weekly sports meetups',
    weeklySubtitle: 'Build your weekly routine',
    everyWednesday: 'Every Wednesday',
    everySaturday: 'Every Saturday',
    everySunday: 'Every Sunday',
    participateThisWeek: 'Join this week',
    // Category section
    findActivity: 'What\'s happening',
    activity: 'near you today',
    findActivityDesc: 'From morning yoga to high-intensity strength training, discover activities that suit you',
    allActivities: 'View all activities',
    // Features section
    whyMotivya: 'Why',
    whyMotivyaDesc: 'Motivya connects coaches and fitness enthusiasts in your neighbourhood.',
    // Coach section
    youAreCoach: 'Are you a',
    coachWord: 'Coach',
    coachSubtitle: 'Grow your local sports community.',
    coachSubtext: 'Attract participants near you and fill your sessions.',
    becomePartner: 'Become a Coach Partner',
    coachBlock1Title: 'Recurring income',
    coachBlock1Text: 'New recurring income, hassle-free.',
    coachBlock2Title: 'Local clients',
    coachBlock2Text: 'Clients nearby. Less travel, more sessions.',
    coachBlock3Title: 'No wasted sessions',
    coachBlock3Text: 'Minimum threshold met = session confirmed.',
    // Social proof
    socialProof: 'Already hundreds of sessions organised in Brussels.',
    // Dynamic stats
    totalParticipants: 'Participants',
    coachesIn: 'Coaches in',
    sessionsThisWeek: 'Sessions this week',
    joinCommunity: 'Join the community',
    // Real-time indicators
    sessionsStartingIn3h: 'sessions starting in the next 3 hours in',
    participantsToday: 'athletes participating in sessions today',
    // Starting soon section
    urgentLabel: 'Starting soon!',
    startingSoonTitle: 'Sessions starting soon',
    startingSoonSubtitle: 'Don\'t miss these activities starting in the next few hours',
    startsIn: 'Starts in',
    today: 'Today',
    // Featured coaches section
    coachesNearbyTitle: 'Coaches in your neighbourhood',
    coachesNearbySubtitle: 'Discover active coaches near you',
    sessionsOrganized: 'sessions',
    totalParticipantsCoach: 'participants',
    viewCoachSessions: 'View sessions',
    // Communities section
    communitiesTitle: 'Sports communities in Brussels',
    communitiesSubtitle: 'Join a group and train regularly',
    members: 'members',
    joinCommunityBtn: 'Join community',
    joinedCommunity: 'You\'ve joined the community!',
    // Map section
    activitiesAroundYou: 'Activities around you',
    filterToday: 'Today',
    filterTonight: 'Tonight',
    filterWeek: 'This week',
    filterNearby: 'Near me',
    mapRadiusInfo: '2 km radius around your location • Click "Locate me" on the map to center',
    // Popular activities
    popularActivities: 'Popular activities',
    // Coaches section
    neighborhoodCoaches: 'Neighbourhood coaches',
    activeCoachesNear: 'Active coaches near',
    allCoaches: 'All coaches',
    viewSessions: 'View sessions',
    // Communities section
    sportsCommunities: 'Sports communities',
    joinGroupRegularly: 'Join local groups to train regularly',
    joinGroup: 'Join group',
    // Coach CTA section
    developCommunity: 'Grow your local sports community',
    joinMotivy: 'Join Motivya and turn your passion into a thriving business',
    fillSessions: 'Fill your sessions',
    findNearbyAthletes: 'Find athletes near you',
    createRecurringIncome: 'Create recurring income',
    becomePartnerCoach: 'Become a partner coach',
    // Stats section
    activeParticipants: 'Active participants',
    certifiedCoaches: 'Certified coaches',
    sessionsThisWeekLabel: 'Sessions this week',
    coveredMunicipalities: 'Covered municipalities',
    // Newsletter section
    receiveSessionsNearYou: 'Get sessions near you',
    beNotifiedNewSessions: 'Be notified of new sessions in your area',
    yourEmail: 'Your email',
    subscribeBtn: 'Subscribe',
    thankYouSubscribed: 'Thank you! You\'re subscribed.',
    // Footer
    footerExplore: 'Explore',
    footerRegister: 'Sign up',
    footerCoach: 'Become a Coach',
    footerActivities: 'Activities',
    footerLegal: 'Legal',
    footerPrivacy: 'Privacy',
    footerTerms: 'Terms',
    footerContact: 'Contact',
    footerLocation: 'Brussels, Belgium',
    footerSlogan: 'Sports in your neighbourhood',
    allRightsReserved: 'All rights reserved.',
  },

  // Community subscription
  community: {
    title: 'Join the Motivya community',
    subtitle: 'Get notified about new sessions near you based on your sports preferences.',
    emailPlaceholder: 'Your email address',
    subscribe: 'Subscribe',
    selectPreferences: 'Choose your favourite activities (optional)',
    privacyNote: 'We respect your privacy. Unsubscribe anytime.',
    subscribed: 'Welcome to the community!',
    subscribedDesc: 'You\'ll soon receive the best sessions near you.',
    subscribeSuccess: 'Successfully subscribed! Welcome to the Motivya community.',
    subscribeError: 'Error subscribing. Please try again.',
    emailRequired: 'Please enter your email address.',
  },

  features: {
    quickBooking: 'Quick Booking',
    quickBookingDesc: '2-3 clicks and you\'re booked. Simple. Fast. Effective.',
    nearby: 'Nearby',
    nearbyDesc: 'Find activities just around the corner with geolocation.',
    trust: 'Trust',
    trustDesc: 'Certified coaches rated by an engaged community.',
    flexibility: 'Flexibility',
    flexibilityDesc: 'Regular or one-off sessions, however you like it.',
  },

  categories: {
    all: 'All',
    yoga: 'Yoga',
    renforcement: 'Strength',
    mobilite: 'Mobility',
    outdoor: 'Outdoor',
    running: 'Running',
    cardio: 'Cardio',
    pilates: 'Pilates',
    boxe: 'Boxing',
    danse: 'Dance',
    padel: 'Padel Lessons',
    tennis: 'Tennis Lessons',
  },

  explore: {
    objectiveTitle: 'What\'s your goal today?',
    personalize: 'Personalise my experience',
    findActivity: 'Find your activity',
    cityPlaceholder: 'City or postcode (e.g. 1050, Ixelles, Schaerbeek...)',
    category: 'Category',
    level: 'Level',
    priceMax: 'Max price (€)',
    clear: 'Clear',
    apply: 'Apply',
    loading: 'Loading...',
    sessions: 'sessions',
    session: 'session',
    resetFilters: 'Reset filters',
    noResults: 'No sessions found',
    noResultsDesc: 'Try adjusting your search criteria',
    clearFilters: 'Clear filters',
    showing: 'Showing first 50 sessions out of',
    confirmed: 'Confirmed',
    pending: 'Pending',
    event: 'Event',
    book: 'Book',
    min: 'min',
    filteringByCoach: 'Sessions by',
  },

  // Timing
  timing: {
    today: 'Today',
    tomorrow: 'Tomorrow',
    thisWeek: 'This week',
    thisWeekend: 'This weekend',
    all: 'All',
    filterByDate: 'Filter by date',
    inMinutes: 'In {{min}} min',
    inOneHour: 'In 1h{{min}}',
    inHours: 'In {{hours}}h{{min}}',
  },

  levels: {
    all: 'All levels',
    debutant: 'Beginner',
    intermediaire: 'Intermediate',
    avance: 'Advanced',
    tous: 'All levels',
  },

  objectives: {
    douceur: 'Ease back in',
    douceurDesc: 'Gentle activities to get back into sports at your own pace',
    regulier: 'Stay active',
    regulierDesc: 'A varied mix to keep a balanced routine',
    challenge: 'Push my limits',
    challengeDesc: 'Intense sessions to challenge yourself',
    jeune: 'Young & ambitious',
    jeuneDesc: 'Energy and drive for the most motivated',
    senior: 'Stay fit 50+',
    seniorDesc: 'Adapted activities for lasting fitness',
    clickToChange: 'Click to change',
  },

  onboarding: {
    welcome: 'Welcome to Motivya!',
    welcomeDesc: 'Find sports activities near you, tailored to your goals and level.',
    sessionsCount: '200+ sessions',
    nearYou: 'Near you',
    certifiedCoaches: 'Certified coaches',
    start: 'Get started',
    objectiveTitle: 'What\'s your goal?',
    objectiveDesc: 'We\'ll personalise your recommendations',
    back: 'Back',
    discover: 'Discover activities',
    locating: 'Locating...',
    locationNote: 'We\'ll use your location to find activities near you',
  },

  coach: {
    noRiskModel: 'Zero-risk model',
    heroTitle1: 'Generate steady income.',
    heroTitle2: 'No risk. No gym required.',
    heroSub1: 'You set your price. You set your minimum threshold.',
    heroSub2: 'The session only starts when it\'s profitable.',
    simulateRevenue: 'Simulate my income',
    createProfile: 'Create my coach profile',
    keyPrinciple: 'Key principle',
    neverAtLoss: 'Never at a loss.',
    neverAtLossDesc: 'The concept that changes everything for independent coaches',
    defineThreshold: 'Set your threshold',
    defineThresholdDesc: 'You choose the minimum number of participants (e.g. 4 people) for the session to be worthwhile.',
    thresholdReached: 'Threshold met = Session confirmed',
    thresholdReachedDesc: 'If the minimum is met, the session is automatically confirmed. You teach, you earn.',
    thresholdNotReached: 'Threshold not met = Automatic cancellation',
    thresholdNotReachedDesc: 'Not enough sign-ups? The session is automatically cancelled. Participants are refunded. No need to travel.',
    zeroLoss: 'Guaranteed zero loss',
    zeroLossDesc: 'No wasted trips. No loss-making sessions. Your time and energy are protected.',
    concreteExample: 'Real-world example',
    pricePerParticipant: 'Price per participant',
    minThreshold: 'Minimum threshold',
    participants: 'participants',
    grossRevenue: 'Gross revenue',
    yourReturn: 'Your complementary income',
    guaranteedSession: 'Guaranteed profitable session',
    returnRange: 'between €42 and €54 depending on your Motivya status',
    calculateReturn: 'Calculate your complementary income',
    adjustParams: 'Adjust the settings and select your plan to see your earnings after commission',
    revenueSimulator: 'Revenue simulator',
    estimateReturn: 'Estimate your monthly complementary income',
    pricePerPerson: 'Price per participant',
    minParticipants: 'Minimum participants',
    avgParticipants: 'Average participants per session',
    sessionsPerMonth: 'Sessions per month',
    plan: 'Plan',
    commission: 'commission',
    monthlySubscription: 'Monthly subscription',
    guaranteed: 'INDICATIVE MINIMUM',
    average: 'AVERAGE INCOME',
    potential: 'POTENTIAL INCOME',
    minMonth: 'indicative/month',
    estMonth: 'estimated/month',
    optMonth: 'optimised/month',
    calcDetail: 'Breakdown (average income):',
    grossRev: 'Gross revenue',
    paymentFees: 'Payment fees (1.5%)',
    commissionMotivya: 'Motivya commission',
    subscription: 'Subscription',
    complementaryReturn: 'Complementary income',
    paymentNote: 'Payment fees: Stripe, PayPal, Bancontact (1.5%)',
    chooseFormula: 'Choose your plan',
    pricingTitle: 'Pricing tailored to your activity',
    pricingDesc: 'The more you commit, the less commission you pay',
    popular: 'POPULAR',
    month: '/month',
    selected: '✓ Selected',
    subscribeTo: 'Subscribe to',
    entrepreneurTitle: 'Run your activity like an entrepreneur',
    entrepreneurDesc: 'All the tools to grow your coaching business',
    setPrices: 'Set your prices',
    setPricesDesc: 'You decide your rates based on your experience and market',
    chooseLocations: 'Choose your venues',
    chooseLocationsDesc: 'Parks, beaches, public spaces... Coach wherever you want',
    profitThreshold: 'Profitability threshold',
    profitThresholdDesc: 'Set the minimum number of participants for each session',
    securePayment: 'Secure payment',
    securePaymentDesc: 'Participants pay upfront. You get paid automatically',
    totalFlexibility: 'Total flexibility',
    totalFlexibilityDesc: 'Create, modify or cancel your sessions in a few clicks',
    zeroAdmin: 'Zero admin',
    zeroAdminDesc: 'Invoicing, refunds, notifications... all automated',
    quote: '"You teach. Motivya secures your profitability."',
    readyTitle: 'Ready to grow your activity risk-free?',
    readyDesc: 'Join the coaches who chose financial security',
    alreadyCoach: 'You\'re already a coach!',
    accessDashboard: 'Go to your dashboard to manage your sessions',
    goToDashboard: 'Go to coach dashboard',
    applicationPending: 'Application under review',
    applicationPendingDesc: 'Your application has been submitted successfully! The Motivya team is currently reviewing it and will be in touch soon.',
    processingTime: 'Usual processing time: 24-48 business hours',
    backHome: 'Back to home',
    applicationRejected: 'Application not selected',
    applicationRejectedDesc: 'Unfortunately, your application was not selected this time.',
    rejectionReason: 'Reason:',
    reapplyNote: 'You can submit a new application after 30 days.',
    applicationTitle: 'Coach Application',
    step: 'Step',
    contactInfo: 'Contact information',
    contactInfoDesc: 'How can we reach you?',
    profilePhoto: 'Profile photo',
    uploadPhoto: 'Upload photo',
    photoHint: 'JPG or PNG, max 5MB. Your photo will appear on your profile.',
    photoUploaded: 'Photo uploaded successfully!',
    photoUploadError: 'Error uploading photo',
    photoInvalidType: 'Please select an image (JPG, PNG)',
    photoTooLarge: 'Photo must not exceed 5MB',
    phone: 'Phone',
    professionalEmail: 'Professional email',
    mainLocation: 'Main location',
    linkedin: 'LinkedIn profile',
    website: 'Website',
    continue: 'Continue',
    proProfile: 'Professional profile',
    proProfileDesc: 'Tell us about your experience',
    presentation: 'Your introduction',
    presentationPlaceholder: 'Describe your background, approach and what sets you apart...',
    experienceYears: 'Years of experience',
    specialties: 'Specialities',
    selectOneMin: '(select at least one)',
    certifications: 'Certifications / Qualifications',
    addCertification: '+ Add a certification',
    motivationTitle: 'Your motivation',
    lastStep: 'Last step before submission',
    whyJoin: 'Why join Motivya?',
    motivationPlaceholder: 'Tell us about your motivation, goals, and what you expect from the platform...',
    summary: 'Summary',
    location: 'Location',
    experience: 'Experience',
    years: 'years',
    chosenPlan: 'Chosen plan',
    submitting: 'Submitting...',
    submit: 'Submit my application',
    submitDisclaimer: 'By submitting this form, you agree that your information will be reviewed by the Motivya team.',
    applicationSent: 'Application sent!',
    applicationSentDesc: 'Thank you! The Motivya team will review your application within 24-48h and contact you by email.',
    publishSessions: 'Publish sessions',
    manageBookings: 'Manage bookings',
    securePaymentFeature: 'Secure payment',
    basicStats: 'Basic statistics',
    prioritySupport: 'Priority support',
    searchVisibility: 'Boosted visibility in searches',
    premiumBadge: '"Premium Coach" badge',
    advancedAnalytics: 'Advanced analytics',
    startFree: 'Start for free',
    chooseActive: 'Choose Active',
    choosePremium: 'Choose Premium',
    // Simulator lock
    simulatorLocked: 'Simulator locked',
    simulatorLockedDesc: 'Create a free account to access the revenue simulator and discover your earning potential.',
    simulatorLockedDescCoach: 'The simulator is reserved for validated coaches. Sign up and book your validation call.',
    createAccount: 'Create free account',
    alreadyHaveAccount: 'Already have an account?',
    iAmCoach: 'I am a coach',
    iAmPractitioner: 'I am a practitioner',
    // Simplified acquisition form
    socialProof: '+100 coaches already trust us',
    joinCommunity: 'Join the community',
    in30Seconds: 'In 3 clicks, book your validation call',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    bookValidationCall: 'Book my validation call',
    call10min: '10 min call with our team',
    profileValidation: 'Validation of your coach profile',
    fullAccess: 'Access to your full coach space',
    alreadyAccount: 'Already registered?',
    loginHere: 'Log in',
    thankYou: 'Thank you!',
    bookCallNow: 'Book your validation call with our team now.',
    bookMyCall: 'Book my call',
    calendlyNote: 'You will be redirected to Calendly',
    fillAllFields: 'Please fill in all fields',
    invalidEmail: 'Invalid email address',
    leadSaved: 'Information saved!',
    // Ambassador page
    launchInProgress: 'Launch in progress',
    foundingCoachTitle: 'Become one of the 90 founding coaches in Brussels',
    foundingCoachSubtitle: 'Join the ambassador program and enjoy exclusive lifetime benefits',
    becomeAmbassador: 'Become an ambassador coach',
    alreadyJoined: 'Already {count} coaches have joined us',
    joinAdventure: 'Be part of the adventure as an ambassador',
    opportunityTitle: 'First come, first served',
    opportunityDesc: 'The first 90 coaches to join Motivya in Brussels get Founding Coach status with exclusive lifetime benefits.',
    noRiskTitle: 'Never at a loss',
    noRiskDesc: 'You set your minimum threshold. If not reached, the session is automatically cancelled.',
    commissionDivided: 'Commission ÷ 2',
    whileActive: 'As long as you\'re active (excluding Freemium)',
    founderBadge: 'Founding Coach Badge',
    badgeForLife: 'Displayed on your profile for life',
    priorityVisibility: 'Priority visibility',
    topSearchResults: 'Top of search results',
    earlyAccess: 'Early access',
    newFeatures: 'To new features',
    productInfluence: 'Product influence',
    participateDecisions: 'Participate in decisions',
    guaranteedReturn: '100% guaranteed return',
    autoAdjust: 'Your subscription choice adjusts automatically to optimize your activity.',
    autoUpgrade: 'If the Premium plan becomes more advantageous for you, we automatically adapt your billing so you\'re always rewarded for your performance.',
    noPrePayment: 'No subscription pre-payment as an ambassador, fees are deducted from your first invoice. Zero risk.',
    readyGo: 'Ready? Go...',
    howItWorks: 'How it works',
    step1Title: 'Create your profile',
    step1Desc: 'Sign up and complete your coach profile in 5 minutes',
    step2Title: 'Publish your sessions',
    step2Desc: 'Create activities with your prices and minimum threshold',
    step3Title: 'Receive your participants',
    step3Desc: 'Motivya promotes your sessions and manages registrations automatically',
    limitedOffer: 'Limited offer',
    ambassadorSpots: '90 ambassador spots for Brussels',
    commissionHalved: 'commission halved',
    freemiumStays: 'Freemium stays at 30% unchanged.',
    plusPaymentFees: '(+ 1.5% payment fees)',
    reserveSpot: 'Reserve my ambassador spot',
    takeAdvantage: 'Get ahead',
    rightNow: 'right now',
    joinCoaches: 'Join the {count} coaches who have already reserved their spot',
    spotsRemaining: 'Join the {remaining} remaining spots',
    createYourProfile: 'Create your profile',
    ambassadorProgram: 'Coach Ambassador Program',
    journeySimulator: 'Interactive Simulator',
    liveExperience: 'Experience the coach journey',
    discoverIn30s: 'Discover how Motivya works in 3 clicks',
    createTestSession: 'Create a test session',
    clickToSeeMagic: 'Click to see the magic happen ✨',
    creation: 'Creation',
    promotion: 'Promotion',
    reservations: 'Bookings',
    thresholdReachedStep: 'Threshold reached',
    payment: 'Payment',
    sessionCreated: '✨ Session created!',
    promotionInProgress: '📣 Promotion in progress...',
    promotingSession: 'Motivya broadcasts your session to local athletes',
    registrationsArriving: '👥 Registrations are coming in!',
    minThreshold: 'Minimum threshold: {count} participants',
    thresholdReached: '🎉 Threshold reached!',
    sessionConfirmed: 'Your session is confirmed',
    participantsRegistered: '{count} participants registered',
    didNothing: '❤️ You didn\'t have to do anything!',
    paymentReceived: '💰 Payment received!',
    coachActive: 'Active Coach',
    coachAmbassador: 'Ambassador Coach',
    asAmbassador: 'as an ambassador',
    invoicesGenerated: 'Invoices generated automatically',
    replayDemo: 'Replay the demo',
    sessionBooked: 'Session booked. Session delivered. Session paid.',
    focusOnPassion: 'Focus on your passion, Motivya handles the rest.',
    exVAT: 'Excl. VAT',
    commissionMotivya: 'Motivya commission',
    transactionFees: 'Transaction fees',
    transactionFeesNote: '(indicative, optimised based on available payment methods)',
    // Additional keys for full translation
    reservedSpots: 'Reserved spots',
    simulateRevenue: 'Simulate your revenue in 3 clicks',
    adjustParameters: 'Adjust parameters according to your activity',
    pricePerParticipant: 'Price per participant',
    minThresholdLabel: 'Minimum participant threshold',
    sessionsPerMonth: 'Sessions per month',
    monthlyNetRevenue: 'Monthly additional income',
    yearlyProjection: 'Yearly projection',
    grossRevenue: 'Gross revenue',
    grossRevenueTVAC: 'Gross revenue incl. VAT',
    yourAdditionalRevenue: 'Your additional revenue',
    yourAdditionalRevenueTVAC: 'Your additional revenue incl. VAT',
    recommendedPlan: 'Recommended plan',
    bestForYourActivity: 'optimal for your activity',
    regularLabel: 'Standard',
    motivyaCommission: 'Motivya commission',
    paymentFees: 'Transaction fees',
    subscription: 'Subscription',
    yourNetRevenue: 'Your additional income',
    estimationNote: 'Estimate based on minimum threshold reached for each session',
    autoAdjustTitle: 'Auto-adjusted subscription',
    autoUpgradeTitle: 'Automatic upgrade',
    noPrePaymentTitle: 'No pre-payment',
    popular: 'POPULAR',
    month: 'month',
    choosePlan: 'Choose',
    startFree: 'Start free',
    concreteExample: 'Concrete example',
    guaranteedProfitable: 'Guaranteed profitable session',
    commissionAndFees: 'Motivya commission + 1.5% payment fees',
    monthlyProjection: 'Monthly projection',
    sessions: 'sessions',
    insteadOf: 'instead of',
    asLongAsActive: 'As long as you\'re active',
    // Journey Simulator
    interactiveSimulator: 'Interactive Simulator',
    liveCoachExperience: 'Experience the coach journey',
    discoverHow: 'Discover how Motivya works in 3 clicks',
    createTestSession: 'Create a test session',
    clickMagic: 'Click to see the magic happen ✨',
    stepCreation: 'Creation',
    stepPromotion: 'Promotion',
    stepBookings: 'Bookings',
    stepThreshold: 'Threshold reached',
    stepPayment: 'Payment',
    sessionCreatedMsg: '✨ Session created!',
    promotionInProgressMsg: '📣 Promotion in progress...',
    motivyaBroadcasts: 'Motivya broadcasts your session to athletes in your area',
    registrationsArriving: '👥 Registrations are coming in!',
    minParticipantsRequired: 'Minimum threshold: {count} participants',
    thresholdReachedMsg: '🎉 Threshold reached!',
    sessionConfirmedMsg: 'Your session is confirmed',
    participantsEnrolled: '{count} participants enrolled',
    didNothingMsg: 'You didn\'t have to do anything!',
    paymentReceivedMsg: '💰 Payment received!',
    regularCoach: 'Active Coach',
    ambassadorCoach: 'Ambassador Coach',
    ambassadorBadge: 'AMBASSADOR',
    asAmbassadorBonus: 'as an ambassador',
    invoicesAuto: 'Invoices generated automatically',
    replayDemo: 'Replay the demo',
    sessionFlow: 'Session booked. Session delivered. Session paid.',
    focusPassion: 'Focus on your passion, Motivya handles the rest.',
    // Hero section
    launchBadge: 'Launch in progress',
    heroMainTitle: 'Become one of the',
    heroFoundingCoaches: '90 founding coaches',
    heroInBrussels: 'in Brussels',
    heroSubtitle: 'Generate steady income.',
    heroSubtitleBold: 'No risk. No gym required.',
    // Opportunity section
    opportunitySectionTitle: 'An opportunity reserved for the',
    opportunityFirstCoaches: 'first coaches',
    opportunityDesc: 'The first coaches get the best time slots and the best clients',
    maxVisibility: 'Maximum visibility',
    maxVisibilityDesc: 'From launch, you\'re on the front line',
    priorityAccess: 'Priority access',
    priorityAccessDesc: 'The first clients are yours',
    localDomination: 'Local domination',
    localDominationDesc: 'Become THE reference in your neighbourhood',
    // No risk model section
    uniqueModel: 'Unique model',
    noLossTitle: 'The only model where you',
    noLossHighlight: 'never lose',
    defineThreshold: 'Set your threshold',
    defineThresholdDesc: 'You set the minimum number of participants required',
    thresholdReached: 'Threshold reached = Session confirmed',
    thresholdReachedDesc: 'You get paid, your participants are confirmed',
    thresholdNotReached: 'Threshold not reached = Auto cancellation',
    thresholdNotReachedDesc: 'No fees, no wasted trip',
    zeroLoss: 'Zero loss',
    zeroLossDesc: 'You never give a session at a loss',
    exampleTitle: 'Real-world example',
    pricePerPart: 'Price per participant',
    grossRev: 'Gross revenue',
    commissionRange: 'Commission (10-30%)',
    paymentFeesEx: 'Payment fees (1.5%)',
    yourNetIncome: 'Your additional income',
    guaranteedProfitableSession: 'Guaranteed profitable session',
    monthlyProjectionLabel: 'Monthly projection (12 sessions)',
    // Ambassador section
    exclusiveLaunch: 'Launch exclusive',
    ambassadorStatus: 'Status',
    coachAmbassadorTitle: 'Coach Ambassador',
    noRiskAdvantage: 'You take no risk. You take the lead.',
    // How it works section
    howItWorksTitle: 'How does it work?',
    step1Title: 'Create your profile',
    step1Desc: 'In 2 minutes, present your specialities and experience',
    step2Title: 'Publish your sessions',
    step2Desc: 'Set location, time, price and minimum threshold',
    step3Title: 'Receive your participants',
    step3Desc: 'Bookings come in, you get paid automatically',
    // Pricing section
    choosePlanTitle: 'Choose your plan',
    ambassadorAdvantages: 'Ambassador coaches',
    exclusiveAdvantages: 'enjoy exclusive benefits',
    // Urgency section
    limitedOfferBadge: 'Limited offer',
    ambassadorSpotsTitle: '90 ambassador spots for Brussels',
    commissionHalvedBenefit: 'commission halved',
    freemiumUnchanged: 'Freemium stays at 30% unchanged.',
    paymentFeesNote: '(+ 1.5% payment fees)',
    noAmbassadorFreemium: 'The Ambassador program is not available with Freemium. Choose Active or Premium to benefit from reduced commission.',
    howItWorksButton: 'How does it work?',
    insteadOfPercent: 'instead of',
    reserveAmbassadorSpot: 'Reserve my ambassador spot',
    // Final CTA section
    getAhead: 'Get ahead',
    rightNow: 'right now',
    joinTheCoaches: 'Join the {count} coaches who have already reserved their spot',
    becomeAmbassadorCoach: 'Become an ambassador coach',
    freeSignup: 'Free signup • No commitment • Validation within 48h',
    // Form section
    createYourProfile: 'Create your profile',
    remainingSpotsJoin: 'Join the {remaining} remaining spots',
    // Already coach
    alreadyCoachTitle: 'You\'re already a coach!',
    accessDashboard: 'Access your dashboard',
    goToDashboard: 'Access dashboard',
    // Footer
    allRightsReserved: 'All rights reserved.',
    // Additional pricing keys
    publishSessions: 'Publish sessions',
    manageBookings: 'Manage bookings',
    securePaymentFeature: 'Secure payment',
    basicStats: 'Basic statistics',
    prioritySupport: 'Priority support',
    searchVisibility: 'Search visibility boost',
    premiumBadge: 'Premium badge',
    advancedAnalytics: 'Advanced analytics',
    startFree: 'Start for free',
    chooseActive: 'Choose Active',
    choosePremium: 'Choose Premium',
    participants: 'participants',
    commissionAndFees: 'Motivya commission + 1.5% payment fees',
    // Ambassador
    ambassadorProgram: 'Ambassador Coach Program',
    applicationSent: 'Your application has been sent!',
    commission: 'Commission',
    perSessionBonus: 'more per session as an ambassador',
    ambassadorAdvantageDesc: 'Commission halved as long as you\'re active',
    sessions: 'sessions',
    year: 'year',
    // LaunchCounter
    alreadyJoined: '{count} coaches have already joined',
  },

  session: {
    bookNow: 'Book now',
    viewDetails: 'View all details',
    inviteFriends: 'Invite friends',
    spotsLeft: 'spots left',
    full: 'Full',
    duration: 'Duration',
    price: 'Price',
    location: 'Location',
    date: 'Date',
    time: 'Time',
    coach: 'Coach',
    level: 'Level',
    equipment: 'Required equipment',
    indoor: 'Indoor',
    outdoor: 'Outdoor',
  },

  common: {
    loading: 'Loading...',
    error: 'Error',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    login: 'Sign in',
    yes: 'Yes',
    no: 'No',
    back: 'Back',
    next: 'Next',
    or: 'or',
    and: 'and',
    sessions: 'sessions',
    pers: 'pers.',
    min: 'min.',
  },

  dates: {
    all: 'All',
    today: 'Today',
    tomorrow: 'Tomorrow',
    thisWeek: 'This week',
    thisWeekend: 'This weekend',
  },

  admin: {
    restrictedAccess: 'Restricted access',
    loginToAccess: 'Sign in to access the administration panel',
    login: 'Sign in',
    administration: 'Administration',
    loggedIn: 'Signed in:',
    coachApplications: 'Coach Applications',
    manageApplications: 'Manage coach applications on Motivya',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    all: 'All',
    noApplications: 'No applications',
    noApplicationsPending: 'No pending applications',
    noApplicationsApproved: 'No approved applications',
    noApplicationsRejected: 'No rejected applications',
    submittedOn: 'Submitted on',
    yearsExp: 'years of experience',
    website: 'Website',
    details: 'Details',
    approve: 'Approve',
    reject: 'Reject',
    rejectionReason: 'Rejection reason',
    applicationDetails: 'Application details',
    personalInfo: 'Personal information',
    fullName: 'Full name',
    email: 'Email',
    professionalEmail: 'Professional email',
    phone: 'Phone',
    locationLabel: 'Location',
    externalLinks: 'External links',
    linkedinProfile: 'LinkedIn profile',
    professionalProfile: 'Professional profile',
    yearsOfExperience: 'Years of experience',
    years: 'years',
    bio: 'Bio',
    specialties: 'Specialities',
    certifications: 'Certifications & Qualifications',
    motivation: 'Motivation',
    submittedAt: 'Submitted on:',
    reviewedAt: 'Reviewed on:',
    rejectApplication: 'Reject this application',
    rejectionPlaceholder: 'Explain the reason for rejection (required)...',
    confirmReject: 'Confirm rejection',
    close: 'Close',
    toastUnauthorized: 'Unauthorised access',
    toastLoadError: 'Error loading applications',
    toastApproved: 'Application approved! The coach has been notified.',
    toastApproveError: 'Error approving application',
    toastRejectReasonRequired: 'Please provide a reason for rejection',
    toastRejected: 'Application rejected. The candidate has been notified.',
    toastRejectError: 'Error rejecting application',
  },

  dashboard: {
    explore: 'Explore',
    favorites: 'Favourites',
    admin: 'Admin',
    profile: 'Profile',
    hello: 'Hello,',
    subtitle: 'Manage your bookings and discover new activities',
    findActivity: 'Find an activity',
    findActivityDesc: 'Discover sessions near you',
    myFavorites: 'My favourites',
    savedSessions: 'Saved sessions',
    myProfile: 'My profile',
    myProfileDesc: 'Manage your personal information',
    nearMe: 'Activities near me',
    geolocated: 'Geolocated',
    filters: 'Filters',
    hide: 'Hide',
    show: 'Show',
    category: 'Category',
    searchRadius: 'Search radius:',
    sessionsFound: 'sessions found',
    inCategory: 'in',
    withinRadius: 'within',
    reset: 'Reset',
    locating: 'Finding your location...',
    youAreHere: 'You are here',
    sessionsAt: 'sessions within',
    viewAll: 'View all',
    upcomingSessions: 'My upcoming sessions',
    noUpcoming: 'No upcoming bookings',
    findNext: 'Find your next activity!',
    exploreSessions: 'Explore sessions',
    confirmed: 'Confirmed',
    sessionValidated: 'Session validated',
    spotLeft: 'spot left',
    spotsLeft: 'spots left',
    viewDetails: 'View details',
    history: 'History',
    cancelled: 'Cancelled',
    cancelledSession: 'Cancelled session',
    refunded: 'Refunded',
    cancelledBadge: 'Cancelled',
    toastNotifNotSupported: 'Notifications are not supported by your browser',
    toastNotifEnabled: 'Notifications enabled!',
    toastNotifDenied: 'Notifications denied',
    toastNotifDisabled: 'Notifications disabled',
    toastNotifError: 'Error enabling notifications',
    confirmCancel: 'Are you sure you want to cancel this booking?',
    toastCancelled: 'Booking cancelled',
    toastCancelError: 'Error cancelling booking',
    notifBody: 'You\'ll receive notifications about new sessions near you!',
  },

  favorites: {
    loginRequired: 'Sign in',
    loginToSee: 'to see your favourites',
    login: 'Sign in',
    title: 'My Favourites',
    sessionSaved: 'session saved',
    sessionsSaved: 'sessions saved',
    noFavorites: 'No favourites',
    noFavoritesDesc: 'Add sessions to your favourites to get notified when spots open up!',
    exploreSessions: 'Explore sessions',
    available: 'Spots available',
    fullWaiting: 'Full - Waiting',
    notifyWhenAvailable: 'You\'ll be notified when a spot opens up',
    full: 'Full',
    spot: 'spot',
    spots: 'spots',
    bookNow: 'Book now',
    notifEnabled: 'Notifications enabled',
    notifDisabled: 'Notifications disabled',
    removeFromFavorites: 'Remove from favourites',
    toastRemoved: 'Removed from favourites',
    toastRemoveError: 'Error removing',
    toastLoadError: 'Error loading favourites',
    toastUpdateError: 'Error updating',
  },

  profile: {
    title: 'My Profile',
    subtitle: 'Manage your personal information',
    coach: 'Coach',
    practitioner: 'Practitioner',
    info: 'Information',
    fullName: 'Full name',
    phone: 'Phone',
    city: 'City',
    cityPlaceholder: 'E.g. Brussels',
    becomeCoach: 'Become a Coach',
    becomeCoachDesc: 'Are you a sports coach? Join our community and offer your sessions.',
    learnMore: 'Learn more',
    save: 'Save',
    toastSaved: 'Profile updated!',
    toastSaveError: 'Error updating profile',
    clickToChangePhoto: 'Click on the photo to change it',
    photoUploaded: 'Photo uploaded!',
    photoUploadError: 'Error uploading photo',
    photoInvalidType: 'Invalid format. Use JPEG, PNG or WebP.',
    photoTooLarge: 'Photo too large. Maximum 5MB.',
  },

  coachDash: {
    calendar: 'Calendar',
    hello: 'Hello,',
    coachSpace: 'Your Motivya coach space',
    newSession: 'New session',
    total: 'Total',
    sessionsCreated: 'Sessions created',
    upcoming: 'Upcoming',
    bookings: 'Bookings',
    totalRevenue: 'Total revenue',
    createSession: 'Create a session',
    publishActivity: 'Publish a new activity',
    myCalendar: 'My calendar',
    managePlanning: 'Manage your schedule',
    myProfile: 'My profile',
    optimizeVisibility: 'Optimise your visibility',
    recentSessions: 'Recent sessions',
    viewAll: 'View all →',
    noSessions: 'No sessions created',
    startFirst: 'Start by creating your first session',
    confirmed: 'Confirmed',
    pending: 'Pending',
    event: 'Event',
    participants: 'participants',
    edit: 'Edit',
    expiredSessions: 'Expired sessions',
    noExpired: 'No expired sessions',
    noRevenue: 'No revenue',
  },

  coachCal: {
    dashboard: 'Dashboard',
    title: 'My Calendar',
    subtitle: 'Manage your scheduled sessions',
    newSession: 'New session',
    dayWithSession: 'Day with session(s)',
    noSessionDay: 'No sessions this day',
    createForDate: 'Create a new session for this date',
    createSession: 'Create a session',
    confirmed: 'Confirmed',
    cancelled: 'Cancelled',
    pending: 'Pending',
    edit: 'Edit',
    allSessions: 'All my sessions',
    noSessions: 'No sessions created',
  },

  createSession: {
    title: 'New Session',
    sessionType: 'Session type',
    regular: 'Regular session',
    regularDesc: 'Recurring activity with repeat option',
    uniqueEvent: 'Unique event',
    uniqueEventDesc: 'One-off session, workshop or masterclass',
    generalInfo: 'General information',
    sessionTitle: 'Session title *',
    titlePlaceholder: 'E.g. Morning Vinyasa Yoga Flow',
    description: 'Description *',
    descriptionPlaceholder: 'Describe your session, its flow, what participants will learn...',
    category: 'Category *',
    select: 'Select',
    level: 'Level *',
    dateTime: 'Date and time',
    startDate: 'Start date *',
    startTime: 'Start time *',
    duration: 'Duration *',
    recurrence: 'Recurrence',
    unique: 'One-time',
    once: 'Only once',
    daily: 'Daily',
    everyDay: 'Every day',
    weekly: 'Weekly',
    everyWeek: 'Every week',
    monthly: 'Monthly',
    everyMonth: 'Every month',
    occurrences: 'Number of occurrences',
    sessionsWillBeCreated: 'sessions will be created',
    consecutiveDays: 'consecutive days',
    weeks: 'weeks',
    months: 'months',
    location: 'Location',
    searchAddress: 'Search an address',
    addressPlaceholder: 'E.g. Cinquantenaire Park, Brussels',
    locationSelected: 'Location selected',
    mapHint: 'Click the map or drag the marker to adjust the position',
    indoor: 'Indoor session',
    indoorDesc: 'Enable if the session takes place indoors',
    participantsAndPricing: 'Participants and pricing',
    minimum: 'Minimum *',
    maximum: 'Maximum *',
    price: 'Price (€) *',
    confirmationThreshold: 'Confirmation threshold',
    equipment: 'Required equipment (optional)',
    equipmentPlaceholder: 'E.g. Yoga mat, water bottle',
    cancel: 'Cancel',
    createSessionBtn: 'Create session',
    createMultiple: 'Create {{count}} sessions',
    toastDateRequired: 'Please select a date',
    toastCategoryRequired: 'Please select a category',
    toastLocationRequired: 'Please set a location',
    toastCreatedMultiple: '{{count}} sessions created successfully!',
    toastCreated: 'Session created successfully!',
    toastError: 'Error creating session',
    dur30: '30 minutes',
    dur45: '45 minutes',
    dur60: '1 hour',
    dur90: '1h30',
    dur120: '2 hours',
  },

  editSession: {
    title: 'Edit session',
    generalInfo: 'General information',
    sessionTitle: 'Session title *',
    description: 'Description *',
    category: 'Category *',
    level: 'Level *',
    dateTime: 'Date and time',
    date: 'Date *',
    startTime: 'Start time *',
    duration: 'Duration',
    location: 'Location',
    address: 'Address / Location *',
    indoor: 'Indoor session',
    participantsAndPricing: 'Participants and pricing',
    minParticipants: 'Minimum participants',
    maxParticipants: 'Maximum participants',
    pricePerPerson: 'Price per person (€)',
    equipment: 'Required equipment',
    cancelSession: 'Cancel session',
    back: 'Back',
    save: 'Save',
    confirmed: 'Confirmed',
    cancelled: 'Cancelled',
    pending: 'Pending',
    participants: 'participants',
    viewPage: 'View page',
    enrolledParticipants: 'Enrolled participants',
    user: 'User',
    select: 'Select',
    toastNotFound: 'Session not found',
    toastLoadError: 'Loading error',
    toastUpdated: 'Session updated!',
    toastUpdateError: 'Error updating session',
    confirmDelete: 'Are you sure you want to cancel this session? All participants will be refunded.',
    toastDeleted: 'Session cancelled',
    toastDeleteError: 'Error cancelling session',
    dur30: '30 minutes',
    dur45: '45 minutes',
    dur60: '1 hour',
    dur90: '1h30',
    dur120: '2 hours',
  },

  sessionDetail: {
    title: 'Session details',
    indoor: 'Indoor',
    outdoor: 'Outdoor',
    practicalInfo: 'Practical information',
    minutes: 'minutes',
    viewOnMap: 'View on map →',
    participants: 'participants',
    spotsLeft: 'spot(s) left',
    full: 'Full',
    minRequired: 'Minimum {{count}} participants required',
    equipment: 'Equipment to bring',
    yourCoach: 'Your Coach',
    yearsExperience: 'years of experience',
    perPerson: 'per person',
    sessionConfirmed: 'Session confirmed',
    waitingParticipants: 'Waiting for participants',
    youAreEnrolled: 'You are enrolled!',
    viewBookings: 'View my bookings →',
    bookNow: 'Book now',
    moreFunTogether: 'More fun with friends!',
    securePayment: 'Secure payment - Free cancellation',
    loginToBook: 'to book this session',
    toastNotFound: 'Session not found',
    toastLoadError: 'Error loading',
    toastLoginRequired: 'Sign in to book',
    toastCoachCannotBook: 'Coaches cannot book sessions',
    toastBooked: 'Booking confirmed! (Simulated payment)',
    toastBookError: 'Error booking',
  },

  coachProfile: {
    title: 'My Coach Profile',
    subtitle: 'Complete your profile to attract more participants',
    fullName: 'Full name',
    phone: 'Phone',
    presentation: 'Presentation',
    bio: 'Bio',
    bioPlaceholder: 'Introduce yourself, your background, your approach...',
    specialties: 'Specialities',
    certifications: 'Certifications',
    addCert: 'Add',
    certPrompt: 'Certification name:',
    experienceAndRates: 'Experience and rates',
    yearsExperience: 'Years of experience',
    hourlyRate: 'Indicative hourly rate (€)',
    serviceArea: 'Service area',
    serviceAreaPlaceholder: 'E.g. Brussels and surroundings',
    save: 'Save',
    toastSaved: 'Profile updated!',
    toastError: 'Error updating profile',
  },

  auth: {
    loginTitle: 'Sign in',
    registerTitle: 'Create an account',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm password',
    name: 'Full name',
    loginBtn: 'Sign in',
    registerBtn: 'Sign up',
    googleLogin: 'Continue with Google',
    noAccount: 'Don\'t have an account?',
    hasAccount: 'Already have an account?',
    signUp: 'Sign up',
    signIn: 'Sign in',
    loginFirst: 'Please sign in first',
    passwordMismatch: 'Passwords do not match',
    passwordTooShort: 'Password must be at least 6 characters',
    registerSuccess: 'Registration successful!',
    completeCoachProfile: 'Complete your profile to become a coach',
    backToHome: 'Back to home',
    joinAs: 'I want to join as',
    practitioner: 'Practitioner',
    practitionerDesc: 'I want to join sports sessions',
    coachOption: 'Coach',
    coachDesc: 'I want to offer sessions',
  },
  whatsapp: {
    inviteFriends: 'Invite friends',
    bookingConfirmed: 'Booking confirmed!',
    spotsLeftInvite: '{{count}} spot(s) left - Invite your friends!',
    shareSession: 'Share this session with your friends',
    shareOnWhatsApp: 'Share on WhatsApp',
    maybeLater: 'Maybe later',
    msgBooked: 'I just booked a fitness session!',
    msgSpotsLeft: '{{count}} spot(s) left! Who\'s joining me?',
    msgBookSpot: 'Book your spot',
    copyLink: 'Copy link',
    linkCopied: 'Link copied!',
    inviteTitle: 'Invite a friend',
    inviteDesc: 'I\'m joining this sports activity on Motivya. Come with me?',
  },

  // Share (multi-platform)
  share: {
    inviteFriend: 'Invite a friend',
    shareVia: 'Share via',
    spotsLeft: '{{count}} spots left',
    spotsLeftMessage: 'Only {{count}} spot(s) left!',
    bookYourSpot: 'Book your spot',
    copied: 'Copied!',
    copyLink: 'Copy link',
    justBooked: 'I just booked!',
    bookingConfirmed: 'Booking confirmed!',
    spotsLeftInvite: '{{count}} spots left, invite your friends!',
    shareWithFriends: 'Share this session with your friends!',
    shareWhatsApp: 'Share on WhatsApp',
    moreOptions: 'More sharing options',
    maybeLater: 'Maybe later',
  },

};

export default en;
